import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "hiddenContainer"]

  connect() {
    this.displayTarget.addEventListener('input', this.updateHiddenFields.bind(this))
    this.displayTarget.addEventListener('blur', this.updateHiddenFields.bind(this))
  }

  updateHiddenFields() {
    const emails = this.displayTarget.value
      .split(',')
      .map(email => email.trim())
      .filter(email => email.length > 0)

    // Validate emails and provide visual feedback
    const invalidEmails = emails.filter(email => !this.isValidEmail(email))
    
    if (invalidEmails.length > 0) {
      this.displayTarget.setCustomValidity(`Invalid email addresses: ${invalidEmails.join(', ')}`)
      this.displayTarget.classList.add('is-invalid')
    } else {
      this.displayTarget.setCustomValidity('')
      this.displayTarget.classList.remove('is-invalid')
    }

    // Clear existing hidden fields
    this.hiddenContainerTarget.innerHTML = ''

    // Create new hidden fields for each email
    emails.forEach((email, index) => {
      const hiddenField = document.createElement('input')
      hiddenField.type = 'hidden'
      hiddenField.name = 'lab[default_cc_or_bcc_emails][]'
      hiddenField.value = email
      hiddenField.id = `lab_default_cc_or_bcc_emails_${index}`
      this.hiddenContainerTarget.appendChild(hiddenField)
    })
  }

  isValidEmail(email) {
    // Use the same email regex pattern as Ruby's URI::MailTo::EMAIL_REGEXP
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    return emailRegex.test(email)
  }
} 